// Centralized placeholders — easy to swap real values later.
export const SITE = {
    brand: "ELLA Online Coaching",
    logoUrl:
        "https://customer-assets.emergentagent.com/job_ella-transform/artifacts/thmlevl1_WhatsApp%20Image%202026-05-15%20at%2011.52.13.jpeg",
    coachName: "Mercedes Köstel",
    contact: {
        email: "ella.coach@icloud.com",
        phoneDisplay: "077 287 40 90",
        phoneIntl: "+41 77 287 40 90",
        whatsappNumber: "+41 77 287 40 90",
        whatsappUrl: "https://wa.me/41772874090",
        instagram: "https://instagram.com/ella.onlinecoach",
        instagramHandle: "@ella.onlinecoach",
        facebook: "https://facebook.com/ellaonlinecoaching",
        facebookHandle: "Ella Online Coaching",
    },
    bookingEmbed: {
        enabled: false,
        url: "https://loopbook.maxwebdesign.ch/embed/ella-online",
        provider: "LoopBook",
    },
    images: {
        heroBackground:
            "https://images.unsplash.com/photo-1545205597-3d9d02c29597?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
        coachPortrait:
            "https://images.unsplash.com/photo-1683575136632-81d17d5a2af2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        consultation:
            "https://images.unsplash.com/photo-1461468611824-46457c0e11fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        fitness:
            "https://images.unsplash.com/photo-1528494553736-33532ee22168?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        therapy:
            "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        // Audiences (dark editorial) — selected to match Flyer 1
        mothers:
            "https://images.unsplash.com/photo-1521493017839-bb43486d1b0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        men:
            "https://images.unsplash.com/photo-1453396450673-3fe83d2db2c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        families:
            "https://images.unsplash.com/photo-1511895426328-dc8714191300?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        strugglers:
            "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        seekers:
            "https://images.unsplash.com/photo-1517817748493-49ec54a32465?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
